<template>
    <div id="classdetailstu">
        <div class="header-wrap">
            <div class="header">
                <span class="left"
                      @click="back"><i class="icon-fanhui"></i></span>
                <em>{{name}}（{{score}}分）</em>
            </div>
        </div>
        <template v-if="loading">
            <div class="wrap"
                 v-if="questions && questions.length > 0">
                <div class="tip">共{{ num }}题( 答对<span>{{num - wrongNum}}</span>题, 答错<span>{{wrongNum}}</span>题 )
                </div>
                <div class="exercises stu_dowork_line"
                     v-for="(data,index) in questions">
                    <div class="quest_title clearfix"
                         v-if="data.asks.length>1">
                        <span class="tit_num">{{index+1}}、</span>
                        <span class="title"
                              v-if="data.type!=8"><span v-html="data.content"></span></span>
                        <p class="title"
                           v-if="data.type==8 && data.article_title"><span v-html="data.article_title"></span></p>
                        <p class="title"
                           v-if="data.type==8"><span v-html="data.article_text"></span></p>

                        <div class="img-wrap"
                             v-if="data.image && data.image.url"><img :src="data.image" /></div>
                        <!--</div>-->
                    </div>
                    <div class="quest_con"
                         v-for="ask,inx in data.asks">
                        <!-- 选择题 -->
                        <div v-if="ask.type==1||ask.type==8||ask.type==7">
                            <div class="judgeicon"
                                 :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                            <choice :ask='ask'
                                    :type="ask.type"
                                    :checked="true"
                                    :myColor='true'
                                    :number="data.asks.length>1?0:index+1"
                                    :mystatus="1"></choice>
                        </div>
                        <!-- 填空 -->
                        <div v-if='ask.type == 2'>
                            <div class="judgeicon"
                                 :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                            <blanks :ask='ask'
                                    :askLength='data.asks.length'
                                    :checked="true"
                                    :myColor='true'
                                    :number="data.asks.length>1?0:index+1"></blanks>
                        </div>
                        <!-- 主观题 -->
                        <div v-if='ask.type == 3'>
                            <div class="judgeicon"
                                 :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                            <!--<subjective :ask='data.asks' :index='inx' :question='ask' :askLength='data.asks.length'></subjective>-->
                        </div>
                        <!-- 连线题 -->
                        <div class="line"
                             v-if="ask.type==4">
                            <div class="judgeicon"
                                 :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                            <lines :ask='ask'
                                   :sheet="ask.user_answer"
                                   :origin='1'
                                   :onlyshow='true'
                                   :result='1'
                                   :checked="true"
                                   :myColor='true'
                                   :number="data.asks.length>1?0:index+1"></lines>
                        </div>
                        <!-- 排序题 -->
                        <div class="line"
                             v-if="ask.type==5">
                            <div class="judgeicon"
                                 :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                            <makes :ask='ask'
                                   :is_answer="true"
                                   :type='ask.type'
                                   :checked="true"
                                   :myColor='true'
                                   :number="data.asks.length>1?0:index+1"></makes>
                        </div>
                        <!-- 断句题 -->
                        <div v-if="ask.type==6">
                            <div class="judgeicon"
                                 :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                            <sentence :ask='ask'
                                      :myColor='true'
                                      :checked="true"
                                      :number="data.asks.length>1?0:index+1"></sentence>
                        </div>
                        <div class='answer-wrap'
                             v-if='ask.type!=7'>
                            <div class="user">
                                <div class="user-answer">正确答案:
                                    <div class="line"
                                         v-if="ask.type==4">
                                        <lines :ask='ask'
                                               :sheet="ask.right_answer"
                                               :origin='1'
                                               :onlyshow='true'
                                               :result='0'
                                               :tag="1"></lines>
                                    </div>
                                    <div v-else-if=" ask.type == 5">
                                        <!-- <make :now ='item' :allnum = 'question.asks.length' :num ='question.num' :aindex="index"></make> -->
                                        <div class="contact_blank">
                                            <span class="blank"
                                                  v-for="num in ask.right_answer"
                                                  v-html="num"
                                                  v-if="num">{{ask.num}}</span>
                                            <!-- <span class="blank" v-for="num in ask.user_answer" v-html="ask.right_answer[num]" v-if="ask.right_answer[num]">{{ask.right_answer[num]}}</span> -->
                                        </div>
                                    </div>
                                    <div v-else-if=" ask.type == 6">
                                        <div class="contact_blank">
                                            <span v-html="ask.point"></span>
                                        </div>
                                    </div>
                                    <div v-else-if=" ask.type == 2">
                                        <!-- <make :now ='item' :allnum = 'question.asks.length' :num ='question.num' :aindex="index"></make> -->
                                        <div class="kong_box">
                                            <span class="kong_span"
                                                  v-for="answer in ask.right_answer"
                                                  v-html="answer">{{answer}}</span>
                                        </div>
                                    </div>
                                    <template v-else>
                                        <span v-for="right in ask.choice_answer"
                                              v-html="right.option"></span>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="nowork"
                 v-else>
                <div v-cloak>
                    没有作业数据
                </div>
            </div>
            <div class="bottom_btn"
                 v-if="!is_active">
                <div @click="reward">奖励和评语</div>
            </div>
        </template>
        <template v-else>
            <loadingS></loadingS>
        </template>
        <!--<div class="foot" v-if="city!=411600">
      <div class="comment items" @click="toComment">写评语</div>
      <div v-if="sptestId == 'null'" class="remind2 items" @click="toRemind">提醒个性化学习</div>
      <div v-else class="remind items">提醒个性化学习</div>
    </div>-->
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue'
import loadingS from 'COMPONENTS/base/tealoading.vue';
import choice from 'VIEWS/chinese/module/result_choose.vue'  //选择题
import blanks from 'VIEWS/chinese/module/result_fill.vue'  //填空题
import lines from 'VIEWS/chinese/module/result_line.vue';     //连线题
import sentence from 'VIEWS/chinese/module/result_sentence.vue';//断句题
import makes from 'VIEWS/chinese/module/result_make.vue';//排序题
export default {
    data () {
        return {
            questions: [],
            testData: [],
            qids: "",
            taskid: this.$route.params.taskid,
            user_id: this.$route.params.user_id,
            name: this.$route.params.username,
            classId: this.$route.params.classid,
            score: this.$route.query.score,
            loading: false,
            is_active: Number(this.$route.query.is_active) || 0,
        }
    },
    computed: {
        /*wrongNum(){
                   let n=0
          this.testData.forEach(d => {
            if (d.user_result === 0) {
              n++
            }
          });
          return n;
        }*/
    },
    methods: {
        back () {
            this.$router.go(-1)
        },
        toComment () {
            this.$router.push('/sx/task/classdetail/commentstu/' + this.name + '/' + this.user_id)
        },
        toRemind () {
            this.$router.push('/sx/task/classdetail/remindstu/' + this.name + '/' + this.user_id)
        },
        wrongnum (data) {
            let n = 0;
            data.forEach(d => {
                d.asks.forEach(a => {
                    if (a.user_result === 0) {
                        n++
                    }
                });
            });
            return n;
        },
        reward () {
            this.$router.push("/tea/perreward/51/" + this.taskid + "/" + this.user_id + "?score=" + this.score + "&name=" + this.name);
        }
    },
    created () {
        //console.log(!this.is_active);
        let type = this.type;
        this.$http.post(API_URL_TASK_API + '/chinese/check/user/task/question', {
            "message_id": this.taskid,
            "user_id": this.user_id,
        }).then(res => {
            this.loading = true;
            if (res.data.response == 'ok') {
                this.questions = res.data.data.question;
                this.wrongNum = this.wrongnum(this.questions);
                let num = 0
                this.questions.forEach(d => {
                    num = num + d.asks.length
                });
                this.num = num
            }
        })
    },
    destroyed () {
    },
    components: {
        loadingS,
        headers,
        sentence,
        choice,
        blanks,
        lines,
        makes
    },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";
[v-cloak] {
    display: none;
}

#classdetailstu {
    min-height: 100vh;
}
.wrap {
    padding-bottom: 96px / $ppr;
}
.header {
    background: #5e89ef;
    .left {
        display: block;
        width: 18px / $ppr;
        height: 34px / $ppr;
        background: url("../img/choose_back.png") 0 0 no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 0.6rem;
        top: 50%;
        -webkit-transform: translate(0, -50%);
        -ms-transform: translate(0, -50%);
        transform: translate(0, -50%);
        font-size: 1.2rem;
    }
}

.tip {
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    font-size: 30px / $ppr;
    background-color: $c-fbg;
    padding: 0 $w;
    margin-bottom: $w;
    span {
        color: #ff6600;
    }
}
.bottom_btn {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 96px / $ppr;
    width: 100%;
    z-index: 8;
    div {
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        background: #5e89ef;
        text-align: center;
        font-size: 30px / $ppr;
        color: #fff;
        line-height: 96px / $ppr;
    }
}
.answer-wrap {
    background-color: #fff;
    border-top: 1px / $ppr solid #dcdcdc;
    .user {
        color: #999;
        font-size: 30px / $ppr;
        .user-answer {
            padding: 35px / $ppr 24px / $ppr;
        }
    }
}

.quest_title {
    position: relative;
    padding: 24px / $ppr;
    line-height: 46px / $ppr;
    font-size: 30px / $ppr;
    color: #333;
    background: #fff;
    p:first-child {
        padding-left: 48px / $ppr;
    }
    .tit_num {
        // position: absolute;
        // top: 24px/$ppr;
        // left: 24px/$ppr;
    }
    /*@include displayFlex();
    .tit_num {
      width: 48px/$ppr;
    }
    div.title-wrap {
      @include flex();
    }*/
}
.quest_title > span {
    float: left;
}
.quest_con {
    position: relative;
    margin-bottom: 24px / $ppr;
}

.nowork {
    color: $c-light;
    text-align: center;
    margin-top: 304px / $ppr;
}

.judgeicon {
    position: absolute;
    right: 24px / $ppr;
    top: 0.6rem;
    z-index: 2;
    width: 40px / $ppr;
    height: 36px / $ppr;
    //background-color: #21BF63;
}

.dui {
    background-image: url(img/icon_dui.png);
    background-size: cover;
}

.cuo {
    background-image: url(img/icon_cuo.png);
    background-size: cover;
}

.exercises {
    // font-family:Monospace;
    background-color: #fff;
    position: relative;
}
.quest_con /deep/ .choose {
    margin-top: 0 !important;
}
.kong_span {
    display: inline-block;
    line-height: 45px / $ppr;
    padding: 20px / $ppr 15px / $ppr 10px / $ppr 0;
}
.blank {
    display: inline-block;
    line-height: 45px / $ppr;
    padding: 20px / $ppr 20px / $ppr 0;
    border-bottom: 1px / $ppr solid #dcdcdc;
    margin-right: 20px / $ppr;
}
// .quest_con /deep/ .askTitle {
// 	padding-top: 0 !important;
// }
</style>
